module.exports = __webpack_public_path__ + "img/Eurocommunicationsservices.5223d399.png";